/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InsuranceType } from './InsuranceType';
import {
    InsuranceTypeFromJSON,
    InsuranceTypeFromJSONTyped,
    InsuranceTypeToJSON,
} from './InsuranceType';

/**
 * 
 * @export
 * @interface TargetCompany
 */
export interface TargetCompany {
    /**
     * 
     * @type {string}
     * @memberof TargetCompany
     */
    name: TargetCompanyNameEnum;
    /**
     * 
     * @type {InsuranceType}
     * @memberof TargetCompany
     */
    type: InsuranceType;
}


/**
 * @export
 */
export const TargetCompanyNameEnum = {
    Aetna: 'Aetna',
    BcbsMichigan: 'BCBS Michigan',
    AnthemBcbsElevanceHealth: 'Anthem BCBS (Elevance Health)',
    BlueCrossBlueShieldBcbs: 'Blue Cross Blue Shield (BCBS)',
    HcscBcbs: 'HCSC BCBS',
    HighmarkBcbs: 'Highmark BCBS',
    Cigna: 'Cigna',
    Humana: 'Humana',
    UnitedHealthcare: 'UnitedHealthcare'
} as const;
export type TargetCompanyNameEnum = typeof TargetCompanyNameEnum[keyof typeof TargetCompanyNameEnum];


/**
 * Check if a given object implements the TargetCompany interface.
 */
export function instanceOfTargetCompany(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function TargetCompanyFromJSON(json: any): TargetCompany {
    return TargetCompanyFromJSONTyped(json, false);
}

export function TargetCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): TargetCompany {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': InsuranceTypeFromJSON(json['type']),
    };
}

export function TargetCompanyToJSON(value?: TargetCompany | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'type': InsuranceTypeToJSON(value.type),
    };
}

